import {
    UPDATE_SEARCH_KEYWORD,
    SUBMIT_SEARCH_BY_ENTER
} from '../actions';

const INIT_STATE = {
    keyword: "", // Giá trị ban đầu của input
    enterPressCount: 0, // <-- Thêm state mới, bắt đầu từ 0
};

export default (state = INIT_STATE, action) => {
  switch (action.type) {
    case UPDATE_SEARCH_KEYWORD:
      return { ...state, keyword: action.payload };

      case SUBMIT_SEARCH_BY_ENTER:
      // Mỗi lần nhận action này, tăng bộ đếm lên 1
      return { ...state, enterPressCount: state.enterPressCount + 1 };

    default:
      return state;
  }
};
